// JS
import React from 'react';
import { renderHTML } from '../../shared/utils';

import Slider from '../../Slider';

const StackedLayout = ({ uniqueId, data, gaBlockName }) => {
  return (
    <section id={'editorial-' + uniqueId} className="container my-24 lg:my-48">
      <Slider
        name="editorial"
        responsive={{
          sm: {
            show: 4,
            spaceBetween: 0,
            direction: 'vertical'
          },
          md: {
            show: 3,
            spaceBetween: 5,
            direction: 'horizontal'
          },
          lg: {
            show: 3
          },
          xl: {
            show: 4
          }
        }}
      >
        {data &&
          data.map((item, i) => {
            return (
              <a
                key={item.contentguid}
                href={item.url}
                className="flex items-end px-6 md:px-0 md:py-2 mb-5 md:mb-0 text-black hover:text-gray-600"
              >
                <div
                  className="w-5/12 bg-cover bg-center aspect-[155/175]"
                  style={{ backgroundImage: `url(${item.icon})` }}
                ></div>
                <div className="w-7/12 mx-5 uppercase mb-1 nq-elements">
                  <h3 className="text-sm md:text-xs mb-5">
                    <div className="font-semibold">{item.block_title}</div>
                    {item.block_sub_title}
                  </h3>
                  {renderHTML(item.block_description, 'text-2xs')}
                </div>
              </a>
            );
          })}
      </Slider>
    </section>
  );
};

export default StackedLayout;
